export default {"src":"/_next/static/media/ribborn.5ba33752.svg","height":112,"width":112,"blurWidth":0,"blurHeight":0};